(function () {
  var MAX_QTY = 10;

  function clampValue(el) {
    var v = parseInt(el.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    if (v > MAX_QTY) v = MAX_QTY;
    if (String(v) !== el.value) {
      el.value = v;
      // Trigger any listeners the theme itself has bound (line item updates m.m.)
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function setupInputs() {
    document
      .querySelectorAll(
        'input[type="number"][name="quantity"], input[type="number"][name^="updates"], .quantity__input, input[data-quantity-input]'
      )
      .forEach(function (el) {
        if (el.dataset.qtyLimitBound) return;
        el.dataset.qtyLimitBound = 'true';
        el.setAttribute('max', MAX_QTY);
        el.addEventListener('change', function () {
          clampValue(el);
        });
        el.addEventListener('input', function () {
          clampValue(el);
        });
        el.addEventListener('blur', function () {
          clampValue(el);
        });
        clampValue(el);
      });
  }

  // Sikkerhedsnet: begræns også alt der sendes direkte til Shopifys kurv-API
  // (fanger quick-add, "Køb nu"-knapper osv. som ikke nødvendigvis går via de synlige inputfelter)
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : input && input.url;
      if (url && init && init.body && /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) {
        var bodyStr = init.body;
        if (typeof bodyStr === 'string') {
          try {
            var data = JSON.parse(bodyStr);
            var changed = false;

            if (typeof data.quantity === 'number' && data.quantity > MAX_QTY) {
              data.quantity = MAX_QTY;
              changed = true;
            }

            if (Array.isArray(data.items)) {
              data.items.forEach(function (item) {
                if (typeof item.quantity === 'number' && item.quantity > MAX_QTY) {
                  item.quantity = MAX_QTY;
                  changed = true;
                }
              });
            }

            if (data.updates && typeof data.updates === 'object') {
              Object.keys(data.updates).forEach(function (key) {
                if (typeof data.updates[key] === 'number' && data.updates[key] > MAX_QTY) {
                  data.updates[key] = MAX_QTY;
                  changed = true;
                }
              });
            }

            if (changed) {
              init.body = JSON.stringify(data);
            }
          } catch (e) {
            /* body var ikke JSON, gør intet */
          }
        }
      }
    } catch (e) {
      /* fejl i sikkerhedsnettet må aldrig blokere selve fetch-kaldet */
    }
    return originalFetch.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupInputs);
  } else {
    setupInputs();
  }
  document.addEventListener('shopify:section:load', setupInputs);

  // Fang antalsfelter der dukker op dynamisk (quick-add modaler, kurv-skuffe m.m.)
  var observer = new MutationObserver(function () {
    setupInputs();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();